/** Mirrors Consumer's core/auth/authSessionLog.ts — structured breadcrumb logging for the auth bootstrap sequence. */
import { environment } from '../../../environments/environment';

export type AuthSessionLevel = 'debug' | 'info' | 'warn' | 'error';

export function logAuthSession(event: string, level: AuthSessionLevel = 'info', data?: unknown): void {
  // FND-020: mirror LoggerService's prod gating — suppress debug/info in production so this
  // breadcrumb logger does not bypass the app's log-level policy by writing to console directly.
  if (environment.production && (level === 'debug' || level === 'info')) return;
  const line = `[auth-session] ${event}`;
  switch (level) {
    case 'debug':
      console.debug(line, data ?? '');
      break;
    case 'warn':
      console.warn(line, data ?? '');
      break;
    case 'error':
      console.error(line, data ?? '');
      break;
    default:
      console.info(line, data ?? '');
  }
}
